export const ANIMAL_GET = "ANIMAL_GET"